import createClient from 'openapi-fetch'

import { paths } from './types'

export const editorClient = createClient<paths>({
  baseUrl: '/editor',
  credentials: 'include',
})
